import { Folder } from '../../db/Folder';
import { LASFile } from '../../db/LASFile';
import type { MediaUnion } from '../../db/MediaUnion';
import { SupportedFileType } from '../las-file-explorer';

export const getMediaIcon = (media: MediaUnion) => {
  if (media instanceof Folder) return 'folder';
  if (media instanceof LASFile) return lasFileIcon(media);
  return 'help';
};

function lasFileIcon(media: LASFile) {
  const extension = media.meta?.extension ?? '';
  switch (extension.toLowerCase() as SupportedFileType) {
    case SupportedFileType.WEBP:
      return 'spider-web';
    case SupportedFileType.GIF:
      return 'gif';
    case SupportedFileType.PDF:
      return 'file-pdf';
    case SupportedFileType.JPG:
    case SupportedFileType.JPNG:
    case SupportedFileType.PNG:
      return 'image';
    case SupportedFileType.MP3:
      return 'music';
    case SupportedFileType.MP4:
      return 'video';
    default:
      return 'file'; // Standard-Icon für unbekannte Typen
  }
}
